/**
 * CFS on-demand Horizon components (T7.1, theme JS budget).
 *
 * Horizon loads ~20 component modules on every page (product form, variant picker, slideshows,
 * volume pricing…), but most CFS pages never render those elements. This imports a module only
 * once its custom element is in the DOM, now or later (quick-add modal, section re-renders).
 * Custom elements upgrade when their definition arrives, so behaviour is unchanged.
 *
 * The tag → module URL map is rendered by snippets/scripts.liquid (#CfsLazyElements) with
 * asset_url, the same URLs as the importmap, so a module imported elsewhere runs once.
 */
const source = document.getElementById('CfsLazyElements');
/** @type {Record<string, string[]>} */
const map = source ? JSON.parse(source.textContent ?? '{}') : {};
const pending = new Set(Object.keys(map));
let selector = [...pending].join(',');

/** @param {ParentNode & Node} root */
function scan(root) {
  if (!selector) return;
  const hit = (/** @type {Element} */ (root)).matches?.(selector) || root.querySelector?.(selector);
  if (!hit) return;
  for (const tag of [...pending]) {
    if ((/** @type {Element} */ (root)).matches?.(tag) || root.querySelector?.(tag)) {
      pending.delete(tag);
      for (const url of map[tag] ?? []) import(url).catch((error) => console.warn('[cfs] Could not load', url, error));
    }
  }
  selector = [...pending].join(',');
  if (!selector) observer.disconnect();
}

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) scan(/** @type {Element} */ (node));
    }
  }
});

scan(document);
if (selector) observer.observe(document.documentElement, { childList: true, subtree: true });
